import { Button } from '@/components/ui/button';
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/ui/command';

import { Menu, MenuItem, MenuSeparator } from '@/components/ui/menu';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import siteConfig from '@/config';
import { cn } from '@/lib/utils';
import PATH_PAGE from '@/router/path';
import { RouteParams } from '@/router/type';
import { useGetWorkspaces } from '@/service/workspace/hook';
import { useWorkspaceStore } from '@/store/workspace';
import { CaretSortIcon, CheckIcon, PlusIcon } from '@radix-ui/react-icons';
import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const HeaderWorkspace = () => {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { workspaceId } = useParams<RouteParams>();
  const workspaceIdByStore = useWorkspaceStore((state) => state.workspaceId);
  const setWorkspace = useWorkspaceStore((state) => state.setWorkspace);

  const [value, setValue] = React.useState(workspaceId || workspaceIdByStore);

  const handleSelectWorkspace = (currentValue: string) => {
    setValue(currentValue);
    setOpen(false);
    setWorkspace(
      data?.find((workspace) => workspace.workspace_id === currentValue) ||
        ({} as any)
    );
    const currentPath = location.pathname;
    const newPath = currentPath.replace(workspaceId as string, currentValue);
    navigate(newPath);
  };

  const { data } = useGetWorkspaces({
    staleTime: 1000 * 60 * 5,
  });
  const workspaces =
    data?.map((workspace) => ({
      value: workspace.workspace_id,
      label: workspace.workspace_name,
    })) || [];

  useEffect(() => {
    if (data && workspaceId) {
      const result = data.find(
        (workspace) => workspace.workspace_id === workspaceId
      );
      if (!result) {
        navigate(PATH_PAGE.setting.profile);
        return;
      }
      setValue(workspaceId);
      setWorkspace(result || ({} as any));
    } else if (data && !value) {
      const defaultWorkspace = data[0];
      setValue(defaultWorkspace.workspace_id!);
      setWorkspace(defaultWorkspace);
    }
  }, [data, workspaceId]);

  if (!workspaceId) return <></>;

  return (
    <>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            variant="ghost"
            role="combobox"
            aria-expanded={open}
            aria-label="Select Workspace"
            className="justify-between"
          >
            <span className="max-w-[200px] truncate">
              {value
                ? workspaces.find((workspace) => workspace.value === value)
                    ?.label
                : 'Select Workspace'}
            </span>
            <CaretSortIcon className="ml-2 h-4 w-4 shrink-0 opacity-50" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="mx-4 max-w-[300px] p-0">
          <Command>
            <CommandInput placeholder="Search workspace" className="h-9" />
            <CommandList>
              <CommandEmpty>No Workspace found.</CommandEmpty>
              <CommandGroup>
                {workspaces.map((workspace) => (
                  <CommandItem
                    key={workspace.value}
                    value={workspace.value!}
                    onSelect={handleSelectWorkspace}
                  >
                    {workspace.label}
                    <CheckIcon
                      className={cn(
                        'ml-auto h-4 w-4',
                        value === workspace.value ? 'opacity-100' : 'opacity-0'
                      )}
                    />
                  </CommandItem>
                ))}
              </CommandGroup>
            </CommandList>
          </Command>
          {siteConfig.services.workspace?.create && (
            <Menu className="pt-0">
              <MenuSeparator />
              <MenuItem
              onClick={() => navigate(PATH_PAGE.dashboard.newWorkspace)}
            >
              <PlusIcon className="mr-2 h-4 w-4" />
                <span>Create Workspace</span>
              </MenuItem>
            </Menu>
          )}
        </PopoverContent>
      </Popover>
    </>
  );
};

export default HeaderWorkspace;
